// src/utils/imageUrl.ts
const USE_STATIC_IMAGES = import.meta.env.VITE_USE_STATIC_IMAGES || 'LOCAL';
const API_BASE  = import.meta.env.VITE_STATIC_URL || 'http://localhost:3000';

/**
 * Dada la “ruta” o “path” que almacenas en tu backend,
 * devuelve la URL completa que debe pedir el <img src=...>
 */
export function getImageUrl(path: string): string {
  if (!path) return ''; // o una placeholder
  if (USE_STATIC_IMAGES === 'LOCAL') {
    return `${API_BASE}${path}`;
  }

  return path;
}
